import type { KotaTur, PaketTip } from "./types"

/**
 * Demo hesap tespiti — §4: "`/paketlerim/` → `mevcut.tip` DEMO_SIRKET/DEMO_MUSAVIR ise
 * kilitleyin. Paket yoksa/normal paketse gösterin."
 */
export const DEMO_TIPLER = new Set<PaketTip>(["DEMO_SIRKET", "DEMO_MUSAVIR"])

/** §4 gövdesindeki `mesaj` gelmezse basılacak yedek metin. */
export const DEMO_KILIT_MESAJI =
  "Demo hesapta gerçek gönderim yapılamaz. Beyanname üretilebilir ve XML indirilebilir."

/** Askı/paket ekranının rotası — interceptor da buraya yönlendirir. */
export const PAKET_ROTASI = "/paket"

export const kotaTurLabels: Record<KotaTur, string> = {
  mukellef: "müşteri",
  bilanco_mukellef: "bilanço müşterisi",
  kullanici: "kullanıcı",
  personel: "personel",
}

export const modulLabels: Record<string, string> = {
  banka: "Banka",
  z_raporu: "Z Raporu",
  okc_okutma: "ÖKC Okutma",
  envanter: "Envanter",
  ozel_raporlar: "Özel Raporlar",
  e_defter: "e-Defter",
  e_envanter: "e-Envanter",
  e_fatura: "e-Fatura",
}

export const hesapDurumLabels = {
  AKTIF: "Aktif",
  ASKIDA: "Askıda",
  HAZIRLANIYOR: "Hazırlanıyor",
} as const
